import { useCallback, useEffect, useState } from 'react'

import { useIsMobile } from '@/hooks/use-mobile'

export type LadderLayoutMode = 'columns' | 'list'

const STORAGE_KEY = 'rubric-ladder-layout'

function readStoredPreference(): LadderLayoutMode {
  if (typeof window === 'undefined') return 'columns'
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored === 'list' ? 'list' : 'columns'
}

/** Desktop preference for competency level editor layout; mobile always uses list. */
export function useRubricLadderLayout() {
  const isMobile = useIsMobile()
  const [preference, setPreferenceState] = useState<LadderLayoutMode>(readStoredPreference)

  useEffect(() => {
    setPreferenceState(readStoredPreference())
  }, [])

  const setPreference = useCallback((mode: LadderLayoutMode) => {
    setPreferenceState(mode)
    window.localStorage.setItem(STORAGE_KEY, mode)
  }, [])

  const effectiveMode: LadderLayoutMode = isMobile ? 'list' : preference

  return {
    mode: effectiveMode,
    preference,
    setPreference,
    isMobile,
    canToggle: !isMobile,
  }
}
